import { AdminApi } from 'stylemix-vue-admin'

export default class GoogleProvisioningApi extends AdminApi {
  constructor(parameters) {
    super('google-provisioning', parameters)
  }

  getConfig() {
    return this.submit('get', 'google-provisioning/config')
  }

  getAuthUrl(token = null, returnUrl = null) {
    const params = {
      token: '',
      return_url: '',
    }
    if (token) {
      params.token = token
    }
    if (returnUrl) {
      params.return_url = returnUrl
    }

    return this.submit('get', `google-provisioning/auth-url/?token=${params.token}&return_url=${params.return_url}`)
  }

  getCurrent() {
    return this.submit('get', 'google-provisioning/current')
  }

  getProvisioning(provisioningId) {
    return this.submit('get', `google-provisioning/${provisioningId}`)
  }

  getProvisioningPublic(provisioningId, token) {
    // For GET requests, AdminApi.submit() merges this.parameters with request params
    // We need to pass token as a parameter to the constructor
    const api = new GoogleProvisioningApi({ token })
    return api.submit('get', `google-provisioning/${provisioningId}/public`)
  }

  checkBilling(provisioningId) {
    return this.submit('post', `google-provisioning/${provisioningId}/check-billing`)
  }

  receiveCredentials(credentials) {
    return this.submit('post', 'google-provisioning/receive-credentials', credentials)
  }

  clearCredentials(provisioningId) {
    return this.submit('post', `google-provisioning/${provisioningId}/clear-credentials`)
  }
}

